import loadable from '@loadable/component';

export const CmsAmpLinksBlockLoadable = loadable(
  () => import('./CmsAmpLinksBlock'),
  { resolveComponent: (module) => module.CmsAmpLinksBlock },
);
